var $e1103cb9b4c13942$exports = {};
$e1103cb9b4c13942$exports = {
  "decrease": function decrease(args) {
    return "\u964D\u4F4E ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "\u63D0\u9AD8 ".concat(args.fieldLabel);
  },
  "numberField": "\u6570\u5B57\u5B57\u6BB5"
};
export { $e1103cb9b4c13942$exports as default };